import { Button, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import CheckImages from 'src/app/shared/components/common/common-image/check-images'
import CommonModal from 'src/app/shared/components/modal/common-modal'
import { colorBorder } from 'src/app/themes/primaryThemeDefault'

interface Props {
  isOpen: boolean
  onClose: () => void
  id: string
  checkNumber: string
}

function ViewCheckImageModal(props: Props) {
  const { isOpen, onClose, id, checkNumber } = props
  const { t } = useTranslation()
  return (
    <CommonModal
      title={t('TransactionResult:modal.title.viewCheckImage')}
      size='large'
      open={isOpen}
      onClose={onClose}
      footer={[
        <Button
          key='cancel-btn'
          style={{
            fontWeight: 600,
            width: '102px',
            height: '32px',
            border: `1px solid ${colorBorder}`,
          }}
          onClick={onClose}
        >
          <Typography.Text style={{ fontSize: 14 }}>{t('ClientSetup:client_setup.close')}</Typography.Text>
        </Button>,
      ]}
    >
      <CheckImages id={id} checkNumber={checkNumber} />
    </CommonModal>
  )
}

export default ViewCheckImageModal
